import { DEFAULT_DESIGN_ID, DesignTemplate, getDesignOrDefault } from './designTemplates';
import { loadActiveDeckDesignId, saveActiveDeckDesignId } from './deckStore';

/** Legacy key — deck design used to leak into the global app theme via this entry. */
const LEGACY_DESIGN_KEY = 'spotdove-design-v1';

/** Design for the deck currently open in preview/editor (not the app chrome). */
export const loadDesignId = (): string => loadActiveDeckDesignId();

export const saveDesignId = (designId: string): void => {
  saveActiveDeckDesignId(designId);
};

export const loadActiveDesign = (): DesignTemplate => getDesignOrDefault(loadDesignId());

/** One-time migration from the old global design key. */
export const migrateLegacyDesignKey = (): void => {
  if (typeof window === 'undefined') {
    return;
  }
  const legacy = window.localStorage.getItem(LEGACY_DESIGN_KEY);
  if (legacy && legacy !== DEFAULT_DESIGN_ID) {
    saveActiveDeckDesignId(legacy);
  }
  window.localStorage.removeItem(LEGACY_DESIGN_KEY);
};
